import { Route, Switch } from 'wouter-preact'
import { Themen } from './screens/Themen.jsx'
import { Lernen } from './screens/Lernen.jsx'
import { Blaettern } from './screens/Blaettern.jsx'
import { Karten } from './screens/Karten.jsx'
import { Editor } from './screens/Editor.jsx'
import { Bildkarten } from './screens/Bildkarten.jsx'
import { Einstellungen } from './screens/Einstellungen.jsx'
import { Statistiken } from './screens/Statistiken.jsx'
import { Daten } from './screens/Daten.jsx'
import { Kopfzeile } from './components/Kopfzeile.jsx'

/**
 * Der Lernbildschirm bringt seinen eigenen Rahmen mit (keine Navigation,
 * DESIGN.md „Lernbildschirm"). Alle anderen Bildschirme laufen in `Seite`.
 */
export function Seite({ titel, children }) {
  return (
    <>
      <Kopfzeile />
      <main class="seite">
        {titel ? <h1 class="seiten-titel">{titel}</h1> : null}
        {children}
      </main>
    </>
  )
}

export function App() {
  return (
    <Switch>
      <Route path="/" component={Themen} />
      <Route path="/lernen" component={Lernen} />
      <Route path="/blaettern" component={Blaettern} />
      <Route path="/karten" component={Karten} />
      <Route path="/karten/neu" component={Editor} />
      <Route path="/karten/bearbeiten" component={Editor} />
      <Route path="/karten/bild" component={Bildkarten} />
      <Route path="/einstellungen" component={Einstellungen} />
      <Route path="/statistiken" component={Statistiken} />
      <Route path="/daten" component={Daten} />
      <Route>
        <Seite titel="Nicht gefunden">
          <p>
            Diese Seite gibt es nicht. <a href="/">Zur Themenliste</a>
          </p>
        </Seite>
      </Route>
    </Switch>
  )
}
